import { React, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Feather, Menu } from "react-feather";
import OtherService from "../../services/Other";
import {
  getColor,
  getIcon,
  formatNumber,
} from "../../constants/commonFunction";
import { addContractorCount } from "../../redux/slices/currentUserSlice";
import BigBox from "../BigBox.js";
import Box from "../Box.js";
import FeatherIcon from "feather-icons-react";
import Accordion from 'react-bootstrap/Accordion';
import { ADANI_TRI_COLOR_PALATE } from '../../constants/common';
import { ACC_COLOR_PALATE, AMBUJA_COLOR_PALATE, DARPAN_COLOR_PALATE, ADANI_COLOR_PALATE } from '../../constants/common';
import CircularSlider from "./CircularSlider.js";
import SummaryBoard from "./SummaryBoard.js";
import ProgressBar from "./ProgressBar.js";
import TierAnimation from "./TierAnimation.js";

const ContractorOverview = ({hierName = ''}) => {
  const [tierName, setTierName] = useState('Tier');
  const [currentPoint, setCurrentPoint] = useState(0);
  const [highestTierMinPoint, setHighestTierMinPoint] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const brandId = JSON.parse(localStorage.getItem("currentBrand")).id;
  const userData = useSelector((state) => state.userTypeSlice.userData);
  
  
  const getTierDetails = async () => {
    try {
      const res = await OtherService.getPerformance();
      
      if(res.success) {
        setHighestTierMinPoint(parseInt(res?.response?.allTiersDetails[3]?.lower_limit));
      }
    } catch (err) {
    }
  }

  useEffect(() => {
      getTierDetails();
  }, [brandId]);

  useEffect(() => {
    setTierName(userData?.tierName);
    setCurrentPoint(userData?.availablePoints);
  }, [brandId, userData]);

  function handleVisibilityChange(isVisible) {
    if (isVisible) {
      setIsLoading(false);
    }
  }
  
    return (
      <div className="w-100">
        <div header={'Tier Details'}>
          <BigBox header={'Tier Details'}>
          </BigBox>
          {
            <div style={{ width: "100%" }}>
              <TierAnimation
                tierName="Platinum"
                currentPoint={300}
                highestTierMinPoint={1000}
              />
            </div>
          }
    
          {/* {tierName && (
            <div style={{ width: "100%" }}>
              <TierAnimation
                tierName={tierName}
                currentPoint={currentPoint}
                highestTierMinPoint={highestTierMinPoint}
              />
            </div>
          )}
    
          {!tierName && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "320px", 
              }}
            >
              <p>No tier attached</p>
            </div>
          )} */}
        </div>
      </div>
    );
    
}

export default ContractorOverview;